import type { Order } from '@/mocks/orders';

interface Props {
  order: Order;
}

export default function DocumentsPanel({ order }: Props) {
  return (
    <div className="bg-white rounded-2xl border border-gray-100 p-6">
      <h3 className="font-black text-base mb-5 flex items-center gap-2" style={{ color: '#0a2342' }}>
        <i className="ri-folder-open-line" />Shipping Documents
      </h3>

      <div className="space-y-3">
        {order.documents.map((doc) => (
          <div
            key={doc.name}
            className={`flex items-center gap-4 p-4 rounded-xl border transition-all ${
              doc.available
                ? 'border-gray-100 hover:border-gray-200 cursor-pointer'
                : 'border-dashed border-gray-200 opacity-50'
            }`}
            onClick={() => {
              if (doc.available) {
                alert(`In a live system, "${doc.name}" would download here. Contact your account manager to receive documents via email.`);
              }
            }}
          >
            <div
              className="w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0"
              style={{ backgroundColor: doc.available ? '#e8f0fb' : '#f3f4f6' }}
            >
              <i className={`${doc.icon} text-base`} style={{ color: doc.available ? '#0a2342' : '#9ca3af' }} />
            </div>
            <div className="flex-1 min-w-0">
              <div className={`text-sm font-bold truncate ${doc.available ? 'text-gray-800' : 'text-gray-400'}`}>
                {doc.name}
              </div>
              <div className="text-xs text-gray-400 mt-0.5">
                {doc.available ? `Issued ${doc.date} · ${doc.type}` : 'Not yet available'}
              </div>
            </div>
            {doc.available ? (
              <div className="flex items-center gap-1.5 text-xs font-black px-3 py-1.5 rounded-lg flex-shrink-0" style={{ backgroundColor: '#e8f0fb', color: '#0a2342' }}>
                <i className="ri-download-line" />Download
              </div>
            ) : (
              <div className="flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-lg flex-shrink-0 bg-gray-100 text-gray-400">
                <i className="ri-time-line" />Pending
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="mt-5 pt-4 border-t border-gray-100 flex items-start gap-2 text-xs text-gray-500">
        <i className="ri-information-line flex-shrink-0 mt-0.5" style={{ color: '#0a2342' }} />
        <span>Documents are sent to your registered email automatically. Contact your account manager if you need re-sending.</span>
      </div>
    </div>
  );
}
